import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { FORMULARY } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        PlanCode5: '',
        FormID: '',
        GPI: '',
        MSC: '',
        Tier: '',
        PACD: '',
        QLCD: '',
        QLDays: '',
        QLMDD: '',
        QLQuantity: '',
        QLTypeCD: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "Plan Code5",
        collectionName: "Formulary"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        PlanCode5: false,
        GPI: false,
        FormID: false
    }
}

export const getFormularyData = createAsyncThunk('data/getFormularyData',
    async (data, { rejectWithValue }) => {
        try {
            let queryByFormulary =
                `query GetFormularyDetails{
                GetFormularyDetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"Formulary",
                isDownload:false,
                ${data.PlanCode5 ? `,plancode5: "${data.PlanCode5}"` : ""}
                ${data.FormID ? `,formid: "${data.FormID}"` : ""}
                ${data.GPI ? `,gpi: "${data.GPI}"` : ""}
                `;

            queryByFormulary += FORMULARY

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryByFormulary, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getFormularyDataDownloadAll = createAsyncThunk('data/getFormularyDataDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryByFormulary =
                `query GetFormularyDetails{
                    GetFormularyDetails(
                collectionName:"Formulary",
                isDownload:true,
                ${data.PlanCode5 ? `,plancode5: "${data.PlanCode5}"` : ""}
                ${data.FormID ? `,formid: "${data.FormID}"` : ""}
                ${data.GPI ? `,gpi: "${data.GPI}"` : ""}
                `;

            queryByFormulary += FORMULARY

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryByFormulary, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const formularySlice = createSlice({
    name: 'formulary',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFormularyData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getFormularyData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetFormularyDetails.totalCount;
                state.data.tableData = response.data.data.GetFormularyDetails.data;
            })
            .addCase(getFormularyData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getFormularyDataDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getFormularyDataDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                //state.data.totalCount = response.data.data.GetMemberPlanYearAllDetails.totalCount;
                state.data.tableData = response.data.data.GetFormularyDetails.data;
            })
            .addCase(getFormularyDataDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = formularySlice.actions;
export default formularySlice.reducer